/* ============
 * Getters for the cvc module
 * ============
 *
 * The getters that are available on the
 * cvc module.
 */

export default {
  paymentsInfo: state => { return state.paymentsParams },
  subscribeInfo: state => { return state.subscribe }
}



// WEBPACK FOOTER //
// ./src/store/modules/payments/getters.js